import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Pagination, Table } from 'src/app/shared/types';
import { TICKET_STATUS_MAPPING } from 'src/app/shared/constants';
import {
  createTicketConversationCell,
  createTicketLinkTableData,
  createTicketOrderIdCells,
  createTicketTableData,
  getTicketPaginationCount,
  isCaptainProfileTicket,
  normalizeTicketDescription,
  openTicketConversation,
} from 'src/app/shared/ticket-table.helper';

import { UserTicketingService } from '../../user-tickets.service';
import { HelperService } from 'src/app/helper.service';
import { ToasterService } from 'src/app/toaster.service';

@Component({
  selector: 'app-captain-tickets',
  templateUrl: './captain-tickets.component.html',
  styleUrls: ['./captain-tickets.component.css']
})
export class CaptainTicketsComponent implements OnInit {

  @Input() captainId: any;
  @Input() mobile: any;
  @Input() captainDetailsToggleableHeaders: string[];
  @Output() toggleHeaders: EventEmitter<any> = new EventEmitter();
  captainTickets: Table;
  dataLoaded = false;

  constructor(
    public ticketingService: UserTicketingService,
    private toasterService: ToasterService,
    public dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.declareTable();
  }

  declareTable() {
    this.captainTickets = new Table({
      toggleableHeaders: this.captainDetailsToggleableHeaders,
      headers: {
        date: 'Created Date',
        ticketId: 'Ticket ID',
        rdOrderId: 'RD Order ID',
        orderId: 'Order ID',
        subject: 'Subject',
        description: 'Description',
        status: 'Status',
        agentAction: 'Agent Action',
        agentReason: 'Agent Reason',
        conversation: 'Conversation'
      },
      pagination: new Pagination(0, 10, 0, [10,15,20],0, true),
      selectedHeader: 3,
      defaultError: 'No Tickets found',
      onRefresh: () => {
        this.captainTickets = null;
        this.ngOnInit();
      },
      data: []
    });
    this.getTickets();
  }

  async getTickets(pageNumber = 1, perPage = 10) {
    this.dataLoaded = false;
    try {
      const response : any = await this.ticketingService.fetchUserTicketsByMobileV3(
        this.captainId, 'captain', this.mobile, pageNumber, perPage
      ).toPromise();
      this.dataLoaded = true;
      if (response && response.tickets) {
        const formattedTickets = this.formatCaptainTickets(response.tickets);
        this.captainTickets.data = formattedTickets;
        this.captainTickets.pagination.perPage = perPage;
        this.captainTickets.pagination.count = getTicketPaginationCount(
          pageNumber - 1,
          perPage,
          response.tickets.length
        );
      }
    } catch(error) {
      console.log('Error while fetching tickets for captain----', error);
      this.dataLoaded = true;
    }
  }

  formatCaptainTickets(captainTickets = []) {
    const formatedTickets = [];
    captainTickets.filter(isCaptainProfileTicket).forEach((item) => {
      const ticket = {
        date: createTicketTableData(HelperService.dateString(item.created_at)),
        ticketId: createTicketLinkTableData(item.ticket_id, item.redirection_url),
        ...createTicketOrderIdCells(item),
        subject: createTicketTableData(item.subject || ''),
        description: createTicketTableData(normalizeTicketDescription(item.description_text) || ''),
        agentAction: createTicketTableData(item.l1_agent_action || ''),
        agentReason: createTicketTableData(item.l1_agent_reason || ''),
        status: createTicketTableData(TICKET_STATUS_MAPPING[item.status] || ''),
        conversation: createTicketConversationCell(() => this.openConversation(item.ticket_id)),
      };
      formatedTickets.push(ticket);
    });

    return formatedTickets;
  }

  openConversation(ticketId) {
    openTicketConversation({
      ticketingService: this.ticketingService,
      dialog: this.dialog,
      toasterService: this.toasterService,
      userId: this.captainId,
      ticketId,
      formatDate: HelperService.dateString,
      userLabel: 'Captain',
    });
  }

  changeInHeader(header) {
    this.toggleHeaders.emit(header);
  }

  onPaginationChange(event) {
    this.getTickets((event.pageNo + 1), event.perPage);
  }
}
